

/**
 * Dispara virtual pageview ao carregar mais dados na tabela JC durante o scroll
 */
function tabelaJcPushVirtualPageView(url){


  dataLayer.push({
    'event':'VirtualPageview',
    'virtualPageURL': '/guia-de-compras/tabela-jc/filtro/' + url,
    'virtualPageTitle': 'Filtro - Tabela JC'
  });

  dataLayerEstadao.push({
    'event':'forcePvCheckout',
    'page': '/guia-de-compras/tabela-jc/filtro/' + url
  });

  gtag('event', 'VirtualPageview', {
    'virtualPageURL': '/guia-de-compras/tabela-jc/filtro/' + url,
    'virtualPageTitle': 'Filtro - Tabela JC'
  });

  gtag('event', 'forcePvCheckout', {
    'virtualPageURL': '/guia-de-compras/tabela-jc/filtro/' + url,
    'virtualPageTitle': 'Filtro - Tabela JC'
  });
}


